import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TSliceInitialState, useAppSelector } from '../../hooks';
import { TProductOrder, TProductOrderResponse, adaptProductOrderFromResponse } from '../../types';
import { BACKEND_ACCOUNT_PRODUCT_ORDER } from '../../backend-paths';


export const accountProductOrderReadGetApi = createAsyncThunk(
	`FETCH/${BACKEND_ACCOUNT_PRODUCT_ORDER}/:id`,
	(payload: number, thunkApi) => {
		const path = `${BACKEND_ACCOUNT_PRODUCT_ORDER}/${payload}`;

		return HttpService.get<TProductOrderResponse>(path).then(result => {
			return adaptProductOrderFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TProductOrder> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const accountProductOrderReadSlice = createSlice({
	name: 'accountProductOrderReadSlice',
	initialState,
	reducers: {
		setAccountProductOrderRead(state, action: PayloadAction<TProductOrder>) {
			state.item = action.payload;
		},

		clearAccountProductOrderRead(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[accountProductOrderReadGetApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[accountProductOrderReadGetApi.fulfilled.type]: (state, action: PayloadAction<TProductOrder>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[accountProductOrderReadGetApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useAccountProductOrderReadSelector = () => useAppSelector(state => state[accountProductOrderReadSlice.name]);

export const { clearAccountProductOrderRead, setAccountProductOrderRead } = accountProductOrderReadSlice.actions;
